export const eventDataTableMessagesEn = {
  'dataExploration.eventDataTable.heading': 'Event data',
  'dataExploration.eventDataTable.heading.av': 'Record data',
  'dataExploration.eventDataTable.noRows.title': 'No event data to display',
  'dataExploration.eventDataTable.noRows.message':
    'The current filter selection does not return any events.',
};
